module.exports = __webpack_public_path__ + "static/media/opa_thumb_even.fec6efaa.webp";